import { type ReactElement } from 'react'
import { ConditionTooltip } from 'app/components/ConditionTooltip'
import { roleCanBeInTeamMember, type RoleData, type RoleId } from '@terros/common'
import { Stack, Switch } from '@mantine/core'
import { useTranslation } from '@front/model'
import { TCard } from '@components'

type Props = {
  teamName: string
  roles: RoleData[]
  selectedRoleIds: RoleId[]
  onToggleRole: (roleId: RoleId, checked: boolean) => void
}

export const TeamRolesCard = ({ teamName, roles, selectedRoleIds, onToggleRole }: Props): ReactElement => {
  const { t } = useTranslation()
  return (
    <TCard>
      <TCard.Header>
        <TCard.Title>{teamName}</TCard.Title>
      </TCard.Header>
      <TCard.Content>
        <Stack gap='xs'>
          {roles.map((role) => (
            <ConditionTooltip
              key={role.roleId}
              refProp='rootRef'
              conditions={[
                {
                  active: !role.canAssign,
                  label: t('You do not have permission to assign {{roleName}}', { roleName: role.name }),
                },
                {
                  active: !roleCanBeInTeamMember(role),
                  label: t('{{roleName}} is no longer allowed for team memberships', { roleName: role.name }),
                },
              ]}
            >
              <Switch
                checked={selectedRoleIds.includes(role.roleId)}
                label={role.name}
                onChange={(e) => onToggleRole(role.roleId, e.currentTarget.checked)}
              />
            </ConditionTooltip>
          ))}
        </Stack>
      </TCard.Content>
    </TCard>
  )
}
